import axios, { AxiosInstance } from 'axios';

const baseURL = import.meta.env.VITE_API_BASE_URL;

if (!baseURL) {
  throw new Error(
    'VITE_API_BASE_URL is not defined in the environment variables.'
  );
}

const api: AxiosInstance = axios.create({
  baseURL,
  withCredentials: true,
  headers: {
    'x-api-key': import.meta.env.VITE_CLIENT_KEY || '',
  },
});

api.interceptors.request.use(
  async (config) => {
    return config;
  },
  (error) => {
    if (import.meta.env.VITE_TEST_MODE === 'true') {
      console.error('Request error:', error);
    }
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (import.meta.env.VITE_TEST_MODE === 'true') {
      console.error('Response error:', error.response || error.message);
    }
    return Promise.reject(error);
  }
);

export default api;
